import { mapGetters, mapActions, mapState } from 'vuex'
import moment from 'moment'

export const Forms = {
  methods: {
    log (param1, param2) {
      console.log(param1, param2 || '')
    },
    postAction ({ action, toName }) {
      if (action) {
        switch (action) {
          case 'exit':
            if (toName) {
              this.$store.dispatch('AskToLeave', false)
              setTimeout(() => {
                this.$router.push({ name: toName })
              }, 50)
            }
            break
          default:
            return true
        }
        return false
      } else return true
    },
    showRef (ref, event) {
      var inp = String.fromCharCode(event.keyCode || event.which)
      if (this.$refs[ref]) {
        if (event.keyCode === 8) {
          event.preventDefault()
          this.$refs[ref].terms = ''
          this.$refs[ref].clear()
          return false
        } else if (!/[a-zA-Z0-9-_ ]/.test(inp)) return false
        this.$refs[ref].show()
        this.$refs[ref].terms += inp.toString().toLowerCase()
      }
    },
    // FOCUS
    focusPrevious (event) {
      if (event.target && event.target.previousElementSibling) {
        event.preventDefault()
        event.target.previousElementSibling.focus()
      }
    },
    focusSelf (event) {
      if (event.target) {
        event.preventDefault()
        event.target.focus()
      }
    },
    focusNext (event, parents, childrens) {
      let element = event.target
      if (element) {
        event.preventDefault()
        let nextElement = event.target.nextElementSibling
        for (var i = 0; i < parents; i++) {
          element = element.parentNode
        }

        nextElement = element.nextElementSibling
        for (i = 0; i < childrens; i++) {
          nextElement = nextElement.childNodes[0]
        }

        if (nextElement) {
          nextElement.focus()
        }
      }
    },
    // CLICK
    click (ref) {
      if (this.$refs[ref].$el) {
        this.$refs[ref].$el.click()
      }
    },
    clickPrevious (event) {
      if (event.target && event.target.previousElementSibling) {
        event.preventDefault()
        event.target.previousElementSibling.click()
      }
    },
    clickSelf (event) {
      if (event.target) {
        event.preventDefault()
        event.target.click()
      }
    },
    clickNext (event) {
      if (event.target && event.target.nextElementSibling) {
        event.preventDefault()
        event.target.nextElementSibling.click()
      }
    }
  }
}

export const Entities = {
  data () {
    return {
      Clientes: [],
      Instalaciones: [],
      TiposIncidencias: [],
      IncidenciaEstados: [],
      Tecnicos: [],
      Programas: [],
      Prioridades: []
    }
  },
  computed: {
    ...mapState({
      getCliente: state => state.entities.cliente || [],
      getInstalacion: state => state.entities.instalacion || [],
      getTipoIncidencia: state => state.entities.tipoIncidencia || [],
      getIncidenciaEstado: state => state.entities.incidenciaEstado || [],
      getTecnico: state => state.entities.tecnico || [],
      getPrograma: state => state.entities.programa || [],
      getPrioridad: state => state.entities.prioridad || []
    }),
    ...mapGetters('entities', ['getEntity', 'findBy', 'filterByIncludes'])
  },
  methods: {
    async asyncClientes (onlyActive = false) {
      if (onlyActive) {
        this.Clientes = (await this.getCliente.filter(x => x.Estado === 'A')) || []
      } else this.Clientes = (await this.getCliente) || []
    },
    async asyncInstalaciones (onlyActive = false) {
      if (onlyActive) {
        this.Instalaciones = (await this.getInstalacion.filter(x => !x.NoActiva)) || []
      } else this.Instalaciones = (await this.getInstalacion) || []
    },
    async asyncTiposIncidencias () {
      this.TiposIncidencias = (await this.getTipoIncidencia) || []
    },
    async asyncIncidenciaEstados () {
      this.IncidenciaEstados = (await this.getIncidenciaEstado) || []
    },
    async asyncTecnicos () {
      this.Tecnicos = (await this.getTecnico) || []
    },
    async asyncProgramas () {
      this.Programas = (await this.getPrograma) || []
    },
    async asyncPrioridades () {
      this.Prioridades = (await this.getPrioridad) || []
    },
    ...mapActions('entities', ['SET_ENTITY', 'GET_ENTITY_ASYNC', 'LOAD_ENTITY']),
    getProgramaBy (cliente, instalacion) {
      this.Programas = []
      if (cliente && instalacion) {
        this.axios
          .get(`${this.$apiUrl('programa')}?cliente=${cliente}&instalacion=${instalacion}`, {
            headers: { 'Content-Type': 'application/json' }
          })
          .then(({ data }) => {
            if (data) {
              let varios = {
                Codigo: 10,
                Nombre: 'Varios',
                ProgramaExterno: false,
                Mantenimiento: false
              }
              if (!data.find(p => p.Codigo === varios.Codigo)) {
                data.push(varios)
              }
              this.Programas = this.$loadSelect(data, 'Nombre', 'Codigo', {
                checkFalse: 'Mantenimiento',
                propsFalse: [{ rightTextColor: 'red' }, { rightIcon: 'mdi-alert' }],
                checkTrue: 'BolsaDeHoras',
                propsTrue: [{ rightTextColor: 'orange' }, { rightIcon: 'mdi-alert' }],
                props: ['Mantenimiento', 'BolsaDeHoras']
              })
            }
          })
          .catch(() => {})
      }
    },
    checkPrograma (codigo = '', prop = 'Mantenimiento') {
      let programa = {}
      programa[prop] = true
      if (codigo) {
        programa = this.Programas.find(x => x['value'] === codigo) || {}
      }
      return programa[prop]
    },
    autocompleteFilter (terms, { field, list }) {
      if (terms === ' ') return list
      const token = terms
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      return list.filter(item =>
        item.label
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .startsWith(token)
      )
    },
    selectFilter (item, queryText, itemText) {
      let token = queryText
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      let label = itemText
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .startsWith(token)

      let value =
        item.value
          .toString()
          .split('/')
          .pop() === token

      return label || value
    },
    selectFilterIncludes (item, queryText, itemText) {
      let token = queryText
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      let label = itemText
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .includes(token)
      let value =
        item.value
          .toString()
          .split('/')
          .pop() === token

      return label || value
    },
    selectUnique (model, list, value = 'value') {
      if (list.length === 1) model = list[0][value]
    },
    findLabel (entity, id, label = 'label', value = 'value') {
      return this.findBy({
        entity: entity,
        id: id,
        label: label,
        value: value
      })
    },
    filterBy (entity, id, value = 'value') {
      return this.filterByIncludes({ entity: entity, id: id, value: value })
    },
    formatDate: function (_date) {
      if (_date) return moment(_date).format('DD/MM/YYYY')
      else return ''
    },
    tableEvenOdd (index) {
      let back = 'grey '
      if (this.$vuetify.dark) {
        if (index % 2 === 0) back = 'tertiary'
        else back += 'darken-3'
      } else {
        if (index % 2 === 0) back += 'lighten-5'
        else back += 'lighten-3'
      }
      return back
    },
    getColor (incidencia, sinAsignar, icon) {
      if (incidencia.Estado === 'C') {
        return 'white--text deep-purple darken-1'
      } else if (incidencia.Estado === 'A') {
        return 'white--text orange darken-1'
      }
      let color = ''
      let date1 = moment()
      let fechaHoy = moment(Date.now()).format('YYYY-MM-DD')
      let date2 = moment(incidencia.FechaIncidencia)
      let date3 = moment(incidencia.FechaProximoAviso).format('YYYY-MM-DD')
      let diff = date1.diff(date2, 'days')

      if (this.$store.getters.Tecnico) {
        if (incidencia.Estado === 'U') {
          color = 'light-green accent-3 black--text'
        } else if (incidencia.Prioridad === 4) color = 'red accent-4'
        else if (incidencia.Prioridad === 5) {
          color = 'light-blue accent-2 black--text'
        } else if (diff < 2) color = 'green lighten-2'
        else if (diff <= 3) color = 'amber lighten-2'
        else if (incidencia.Prioridad !== 3 && diff >= 3) {
          color = 'deep-orange lighten-2'
        } else if (this.$vuetify.dark) color = 'white--text'
      } else color = 'green lighten-2'

      if (fechaHoy === date3) {
        color = 'pink'
      }

      if (sinAsignar && incidencia.TecnicoAsignado === 0) {
        color = 'purple lighten-4'
      }
      if (icon) {
        if (color === 'white--text' && this.$vuetify.dark) color = 'white'
        else color = 'black'
      }
      return color
    }
  }
}
